import React from "react";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import PropTypes from "prop-types";

import useStyles from "./RbButton.styles";

export const RbButton = React.forwardRef(function RbButton(props, ref) {
  const { loading, children, ...other } = props;

  const classes = useStyles(props);

  return (
    <Button {...other} ref={ref} classes={classes}>
      {loading && <CircularProgress size={12} className={classes.loading} />}
      {children}
    </Button>
  );
});

RbButton.propTypes = {
  /** Add a loading icon */
  loading: PropTypes.bool,
  /** @ignore */
  children: PropTypes.node,
};

RbButton.defaultProps = {
  loading: false,
  children: undefined,
};

RbButton.displayName = "RbButton";

export default React.memo(RbButton);
